import React, { useState } from 'react';
import styles from './features.module.css'
import { MessageIcon, SuitIcon, ThumbsIcon, TruckIcon } from '../../../../../Svg';

const Features = () => {


    return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <div className={styles.featuresContainer}>
                <div className={styles.featuresCol}>
                    <div className={styles.featuresCol1}>
                        <SuitIcon />
                    </div>
                    <div className={styles.featuresCol1}>
                        <span>
                            Trusted Supply
                        </span>
                        <p>Sourced only from verified and authorized partners.</p>
                    </div>
                </div>
                <div className={styles.featuresCol}>
                    <div className={styles.featuresCol1}>
                        <TruckIcon />

                    </div>
                    <div className={styles.featuresCol1}>
                        <span>
                            On-Time Delivery
                        </span>
                        <p> Plan, schedule, and receive exactly when you need it.</p>
                    </div>
                </div>
                <div className={styles.featuresCol}>
                    <div className={styles.featuresCol1}>
                        <ThumbsIcon />

                    </div>
                    <div className={styles.featuresCol1}>
                        <span>
                            Smarter Sourcing
                        </span>
                        <p> Make faster, informed decisions with intelligent tools.</p>
                    </div>
                </div>
                <div className={styles.featuresCol}>
                    <div className={styles.featuresCol1}>
                        <MessageIcon />

                    </div>
                    <div className={styles.featuresCol1}>
                        <span>
                            Expert Support
                        </span>
                        <p> Real help from people who know procurement.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Features